enum SubscriptionUpdateSourceEnum {
    // There are other sources, but these are the only valid sources for direct subscription updates by a customer.
    ACCOUNT_DASHBOARD = "ACCOUNT_DASHBOARD",
    REACTIVATION_WIZARD = "REACTIVATION_WIZARD",
    CANCELLATION_WIZARD = "CANCELLATION_WIZARD",
}

export default SubscriptionUpdateSourceEnum;
